export const newsEntryTranslations = {
    en: {
        readMore: "Read more",
        pressRelease: "Press release",
    },
    "en-GB": {
        readMore: "Read more",
        pressRelease: "Press release",
    },
    fr: {
        readMore: "En savoir plus",
        pressRelease: "Communiqué de presse",
    },
    de: {
        readMore: "Weitere Informationen",
        pressRelease: "Pressemitteilung",
    },
    it: {
        readMore: "Leggi di più",
        pressRelease: "Comunicato stampa",
    },
    ja: {
        readMore: "さらに読む",
        pressRelease: "プレスリリース",
    },
};
